import api from './api';

const settingsService = {
    // ============================================
    // GET SETTINGS - Public endpoint (no auth)
    // ============================================
    getSettings: async () => {
        const response = await api.get('/settings');
        return response.data.settings;
    },

    // ============================================
    // UPDATE SETTINGS - Admin only
    // ============================================
    updateSettings: async (data) => {
        const response = await api.put('/admin/settings', data);
        return response.data;
    },

    // ============================================
    // UPLOAD LOGO - Admin only
    // ============================================
    uploadLogo: async (file) => {
        const formData = new FormData();
        formData.append('logo', file);

        const response = await api.post('/admin/settings/logo', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    },
};

export default settingsService;
